import React from 'react'
import Typography from '@mui/material/Typography'
import { Link } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

import { Participant } from 'types/Participants'
import { SelectAll as SelectAllObjType } from 'types/SelectAll'
export interface SelectAllProps {
  totalCount: number
  pageLvlCount: number
  selectedAllFlag: boolean
  selectAllVisibleFlag: boolean
  setSelectAllObj: (param1: SelectAllObjType) => void
  onSelection: (param1: Participant[]) => void
}

// Understanding terms:
// Page Level - Participants present in one page for eg if there are 100 participants and we are displaying 10 participants per page,
// page level particpants are those 10 participants
// Grid level - In the same example all the 100 participants are contained in grid level
// You can either select few or all the participants on page and grid level

const SelectAll = (props: SelectAllProps) => {
  const {
    totalCount,
    pageLvlCount,
    selectedAllFlag,
    selectAllVisibleFlag,
    setSelectAllObj,
    onSelection,
  } = props
  const { t } = useTranslation()
  return (
    <>
      <Box
        style={{ textAlign: 'center' }}
        data-testid="select-all-component"
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'row',
        }}
      >
        {selectedAllFlag && (
          <>
            <Typography>
              {t('participant.selectAll.onGridLevel', {
                count: totalCount,
              })}
            </Typography>
            <Typography>&nbsp;</Typography>
            <Typography>
              <Link
                data-testid="clear-all-selected"
                onClick={() => {
                  setSelectAllObj({
                    allVisible: false,
                    all: false,
                    page: 0,
                  })
                  onSelection([])
                }}
                underline="hover"
              >
                {t('participant.selectAll.clearSelection')}
              </Link>
            </Typography>
          </>
        )}

        {selectAllVisibleFlag && !selectedAllFlag && (
          <>
            <Typography>
              {t('participant.selectAll.onPageLevel', {
                count: pageLvlCount,
              })}
            </Typography>
            <Typography>&nbsp;</Typography>
            <Typography>
              <Link
                data-testid="select-all-grid-level"
                onClick={() => {
                  setSelectAllObj({
                    allVisible: false,
                    all: true,
                    page: 0,
                  })
                }}
                underline="hover"
              >
                {t('participant.selectAll.toBeSelectedOnGridLevel', {
                  count: totalCount,
                })}
              </Link>
            </Typography>
          </>
        )}
      </Box>
    </>
  )
}

export default SelectAll
